import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import TrendingGrid from './components/TrendingGrid';
import LatestArticles from './components/LatestArticles';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "黑料吃瓜在线",
      "url": "http://yusuwangluo.cn/",
      "description": "黑料吃瓜在线中心，直达51黑料吃瓜在线观看、黑料吃瓜在线视频等核心栏目。每日更新热门网络爆料事件。",
      "email": "hello@yusuwangluo.cn",
      "telephone": "400-888-6666",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "建国路88号SOHO现代城A座1208室",
        "addressLocality": "北京",
        "addressRegion": "朝阳区",
        "addressCountry": "CN"
      }
    },
    {
      "@type": "WebSite",
      "name": "黑料吃瓜在线",
      "url": "http://yusuwangluo.cn/",
      "description": "黑料吃瓜在线中心，每日更新热门网络爆料事件。"
    },
    {
      "@type": "WebPage",
      "name": "黑料吃瓜在线 - 首页",
      "url": "http://yusuwangluo.cn/",
      "description": "黑料吃瓜在线中心，直达51黑料吃瓜在线观看、黑料吃瓜在线视频等核心栏目。",
      "isPartOf": { "@type": "WebSite", "name": "黑料吃瓜在线", "url": "http://yusuwangluo.cn/" }
    }
  ]
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <TrendingGrid />
        <LatestArticles />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}